import { render, staticRenderFns } from "./UploadSingleImage.vue?vue&type=template&id=1c4500f6&scoped=true"
import script from "./UploadSingleImage.vue?vue&type=script&lang=ts"
export * from "./UploadSingleImage.vue?vue&type=script&lang=ts"
import style0 from "./UploadSingleImage.vue?vue&type=style&index=0&id=1c4500f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4500f6",
  null
  
)

export default component.exports